import React from 'react'
import { Modal as ReactModal } from 'react-bootstrap'
import _ from 'underscore'
import FocusLock from 'react-focus-lock'

export const Modal = (props) => {
  const {
    'aria-labelledby': ariaLabelledby,
    'aria-describedby': ariaDescribedby,
    'aria-label': ariaLabel,
    bsSize,
    onRequestHide,
    onClose,
    onHide,
    isOpen,
    show,
    enforceFocus = false,
    restoreFocus = true,
    responsive,
    cfModal
  } = props

  const dialogProps = {
    'aria-labelledby': ariaLabelledby || props.ariaLabelledby,
    'aria-describedby': ariaDescribedby || props.ariaDescribedby,
    'aria-label': ariaLabel || props.ariaLabel,
    bsSize,
    'aria-modal': true,
    ...props,
  }

  const hideModal = !_.isUndefined(onClose)
    ? onClose
    : !_.isUndefined(onHide)
    ? onHide
    : onRequestHide

  const isModalOpen = !_.isUndefined(show) ? show : isOpen
  const whiteList = (el) => {
    if (
      el.getAttribute('role') === 'dialog' ||
      el.getAttribute('id') === 'clipboard-text'
    ) {
      return false
    }
    return true
  }
  return (
    <ReactModal
      {...dialogProps}
      className={`${props.className}`}
      onHide={hideModal}
      show={isModalOpen}
      enforceFocus={enforceFocus}
      restoreFocus={restoreFocus}>
      {/*<FocusLock
        disabled={!isModalOpen}
        whiteList={whiteList}
        persistentFocus={false}>
        {props.children}
      </FocusLock>*/}
    </ReactModal>
  )
}

export const ModalBody = ReactModal.Body
export const ModalHeader = ReactModal.Header
export const ModalTitle = ReactModal.Title
export const ModalFooter = ReactModal.Footer
